import { KnownPricePaymentMethod } from '@modules/ticket-fares-store';

export interface IFlexiTicketSummary {
  id: number;
  name: string;
  price: number;
  paymentMethodType: KnownPricePaymentMethod;
}

export interface IFlexiTicketSummaryWithQty extends IFlexiTicketSummary {
  count: number;
}
